import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, OnInit, Inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { OrgSettingsService } from '../../../org-settings/org-settings.service';
import { UpdatePatientProcedureNotesCommand } from '../../../DTOs/PatientProcedures/Commands/UpdatePatientProcedureNotesCommand';
import { AuthService } from 'src/auth/auth.service';
import * as moment from 'moment';

export class PatientProcedureNotesDTO {
  text: string;
  date: Date;
  memberEmail: string;
}

@Component({
  selector: 'add-notes-dialog',
  templateUrl: './add-notes-dialog.html',
  styleUrls: ['./add-notes-dialog.scss'],
})
export class AddNotesDialog implements OnInit {

  PPDayID = '';
  procedureNotes: Array<PatientProcedureNotesDTO> = [];
  procedureName = '';
  procedureDay = '';
  newNoteText = '';


  messageErr: string = '';
  ShowErr: boolean = false;
  ShowLoading: boolean = true;
  ShowForm: boolean = false;


  constructor(
    private orgSettingsService: OrgSettingsService,
    private authService: AuthService,
    public dialogRef: MatDialogRef<AddNotesDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {

    this.PPDayID = this.data.selectedPPDayID;
    this.procedureName = this.data.procedureName;
    this.procedureDay = this.data.procedureDay;

    //--------------------------------------------
    // Load Notes - begin
    //--------------------------------------------
    this.orgSettingsService.getPatientProcedureNotes(this.PPDayID)
      .subscribe(
        (response: Array<PatientProcedureNotesDTO>) => {

          this.procedureNotes = response;

          if (environment.debug_mode) {
            console.log('getPatientProcedureNotes, response: ' + JSON.stringify(response));
            console.log('NotesNumber: ' + response.length);

          }

          this.ShowLoading = false;
          this.ShowForm = true;

        }

        ,
        error => {
          console.error(error);
          this.ShowErr = true;
          this.messageErr = <string>error.message;
          this.ShowLoading = false;
          this.ShowForm = true;

        });

    //--------------------------------------------
    // Load Notes - end
    //--------------------------------------------   



    if (environment.debug_mode) {
      console.log('AddNotesDialog Init: Notes=' + this.procedureNotes);
    }

  }

  onNoClick(): void {
    this.dialogRef.close(this.procedureNotes.length);
  }

  onSaveClick(): void {

    if (environment.debug_mode) {
      console.log('AddNotesDialog onSaveClick: saving:' + this.newNoteText);
    }

    this.messageErr = '';
    this.ShowErr = false;
    this.ShowLoading = true;
    this.ShowForm = false;

    if (!this.newNoteText) {
      return;
    }

    //////////////////////////////////////////
    // Save Notes -begin
    //////////////////////////////////////////
    const upd: UpdatePatientProcedureNotesCommand = new UpdatePatientProcedureNotesCommand();
    upd.patientProcedureDayId = this.PPDayID;
    upd.text = this.newNoteText;
    upd.date = moment().utc().toDate();
    upd.memberEmail = this.authService.currentUser.username;

    this.orgSettingsService.updatePatientProcedureNotes(upd)
      .subscribe(() => {

        if (environment.debug_mode) {
          console.log('Saved new notes successfully. response');
        }
        this.newNoteText = undefined;

        this.procedureNotes.push({
          text: upd.text,
          date: upd.date,
          memberEmail: upd.memberEmail
        });
        this.ShowLoading = false;
        this.ShowForm = true;

        //this.dialogRef.close(response.text);

      },
        (error) => {
          console.error(error);
          this.ShowErr = true;
          this.messageErr = <string>error.message;
          this.ShowLoading = false;
          this.ShowForm = true;
        }
      );
    ///////////////////////////////////////////
    // Save Notes - end
    //////////////////////////////////////////

  }

}
